import { createSelector } from 'reselect';

import { configSelector } from 'rewards/app/state/selectors';
import { loyaltyStatusSelector } from 'shared/app/bundles/user';

export const universalBenefitCardsSelector = createSelector(
  [configSelector],
  (config) => {
    if (!config?.universalBenefitCards) {
      return [];
    }

    return config.universalBenefitCards.filter(
      (card) => card && card.enabled && card.id
    );
  }
);

export const userLoyaltyLevelSelector = createSelector(
  loyaltyStatusSelector,
  (userLoyatyStatus) => {
    return userLoyatyStatus?.level;
  }
);
